import { Mail, Send } from "lucide-react";
import { useLang } from "@/contexts/LangContext";
import { useUser } from "@/contexts/userContext";
import { needsEmailVerification, useResendVerification } from "@/hooks/useResendVerification";

export default function EmailVerificationBanner() {
  const { t } = useLang();
  const { user } = useUser();
  const { cooldown, sending, resend } = useResendVerification();

  if (!needsEmailVerification(user)) {
    return null;
  }

  return (
    <div
      className="email-verify-banner glass-card"
      role="status"
      data-testid="email-verification-banner"
    >
      <span className="topup-fx" aria-hidden="true" />
      <div className="email-verify-banner-inner">
        <span className="email-verify-banner-icon-wrap">
          <Mail className="email-verify-banner-icon" size={18} aria-hidden />
        </span>
        <p className="email-verify-banner-text">{t("email_verify_banner")}</p>
      </div>
      <button
        type="button"
        className="email-verify-banner-btn"
        onClick={resend}
        disabled={cooldown > 0 || sending}
        data-testid="email-verification-resend"
      >
        {cooldown > 0 ? null : <Send size={13} aria-hidden />}
        {cooldown > 0
          ? `${t("email_verify_resend_wait")} ${cooldown}s`
          : t("email_verify_resend")}
      </button>
    </div>
  );
}
